import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Submit from './pages/Submit';
import Tickets from './pages/Tickets';
import Sponsors from './pages/Sponsors';
import Affiliates from './pages/Affiliates';
import AffiliateDashboard from './pages/AffiliateDashboard';
import SponsorDashboard from './pages/SponsorDashboard';
import Admin from './pages/Admin';
import FAQ from './pages/FAQ';
import About from './pages/About';
import Contact from './pages/Contact';
import Press from './pages/Press';

const CaptureReferral = () => {
  const { search } = useLocation();
  useEffect(() => {
    const params = new URLSearchParams(search);
    const ref = params.get('ref');
    if (ref) {
      localStorage.setItem('synema_ref', ref);
    }
  }, [search]);
  return null;
};

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.replace('#', ''));
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: 'smooth' }), 100);
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
};

function App() {
  return (
    <div className="bg-dark min-h-screen text-white font-body">
      <CaptureReferral />
      <ScrollToTop />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/submit" element={<Submit />} />
        <Route path="/tickets" element={<Tickets />} />
        <Route path="/sponsors" element={<Sponsors />} />
        <Route path="/affiliates" element={<Affiliates />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/press" element={<Press />} />
        <Route path="/affiliate-dashboard" element={<AffiliateDashboard />} />
        <Route path="/sponsor-dashboard" element={<SponsorDashboard />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
